import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

class MenuItem extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }
  handleClick(ev) {
    const { context, onClick } = this.props
    onClick(context)
  }
  render() {
    const { className, label, context, content } = this.props
    return (
      <li className={className} onClick={this.handleClick}>
        {content || <FormattedMessage id={label} values={context} />}
      </li>
    )
  }
}

export default MenuItem
